import Icon from 'veui/components/Icon'

Icon.register({
  filter: {
    paths: [
      {
        d: 'M256 736a32 32 0 01-32-32V326.41L70.12 114.82A32 32 0 0196 64h480a32 32 0 0125.88 50.82L448 326.41V640a32 32 0 01-20.12 29.71l-160 64A31.81 31.81 0 01256 736zm-97.16-608l123 169.18A32 32 0 01288 316v340.74l96-38.41V316a32 32 0 016.12-18.82L513.16 128zM704 352a32 32 0 00-32-32H544a32 32 0 000 64h128a32 32 0 0032-32zm0 128a32 32 0 00-32-32H544a32 32 0 000 64h128a32 32 0 0032-32zm0 128a32 32 0 00-32-32H544a32 32 0 000 64h128a32 32 0 0032-32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
